export { ContactProfilePage } from '@/components/pages/contact/ContactProfile';
